import { cva } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const skeleton = cva('block animate-shimmer bg-bg-elevated', {
  variants: {
    kind: {
      line: 'h-3 w-40 rounded-md',
      block: 'h-18 w-30 rounded-md',
      circle: 'size-10 rounded-full',
    },
  },
  defaultVariants: { kind: 'line' },
});

export interface SkeletonProps {
  /** Matches the Figma `Kind` property. */
  kind?: 'line' | 'block' | 'circle';
  className?: string;
}

export function Skeleton({ kind, className }: SkeletonProps) {
  return <span aria-hidden className={cn(skeleton({ kind }), className)} />;
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

/** A paragraph of skeleton lines, with the last one short so it reads as text. */
export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <span className={cn('flex flex-col gap-2', className)} role="presentation">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} kind="line" className={index === lines - 1 ? 'w-1/2' : 'w-full'} />
      ))}
    </span>
  );
}
